export const FlowsSharedRoutes = [
  {
    path: "/preview/node/:id",
    name: "previewNode",
    component: () => import("@/domain/Flows/shared/presentation/pages/PreviewNodePage.vue"),
    meta: { requiresAuth: true, permissions: "flows.read" },
  },
  {
    path: "/preview/flow/:id",
    name: "previewFlow",
    component: () => import("@/domain/Flows/shared/presentation/pages/PreviewFlowPage.vue"),
    meta: { requiresAuth: true, permissions: "flows.read" },
  },
];
